"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoneSchema = void 0;
const zod_1 = require("zod");
const XYPosition_1 = require("./XYPosition");
exports.ZoneSchema = zod_1.z.object({
    type: zod_1.z.literal('zone'),
    layer: zod_1.z.number(),
    polygons: zod_1.z
        .object({
        points: XYPosition_1.XYPositionSchema.array(),
        filled: zod_1.z.coerce.boolean().optional(),
        lineWidth: zod_1.z.number().optional(),
    })
        .array(),
    net: zod_1.z.string(),
});
//# sourceMappingURL=Zone.js.map